import { Component, Input, OnInit } from "@angular/core";
import { formatDate } from "@angular/common";
import { TraceClassDecorator } from "@sentry/angular";
import { APPOINTMENT_STATUS } from "src/app/constant/constant";
import { AppointmentHistory } from "src/app/models/appointment";

interface historyModel {
    sr_no: number;
    action_date: string;
    action_type: string;
    reason: string;
    doctor_name: string;
    status: number;
    appointment_date: string;
}

@Component({
    selector: "app-patient-appointment-history",
    templateUrl: "./patient-appointment-history.component.html",
    styleUrls: ["./patient-appointment-history.component.css"],
})
@TraceClassDecorator()
export class PatientAppointmentHistoryComponent implements OnInit {
    @Input("history") history: AppointmentHistory;
    apptStatus: string[] = APPOINTMENT_STATUS;
    history_array: historyModel[] = [];
    constructor() { }

    async ngOnInit(): Promise<void> {
        await this.Preprocess();
    }

    private async Preprocess(): Promise<void> {
        const appts = this.history.appointments;
        if (!appts.length) {
            this.history_array.push(
                {
                    sr_no: 1,
                    action_date: appts[0]?.created_at.toString(),
                    action_type: "Pending",
                    reason: "N/A",
                    doctor_name: "N/A",
                    status: 5,
                    appointment_date: "N/A"
                }
            )
        } else {
            this.history_array.push(
                {
                    sr_no: 1,
                    action_date: appts[0]?.created_at.toString(),
                    action_type: this.apptStatus[0],
                    reason: "N/A",
                    doctor_name: appts[0]?.egd_appointments.map(d => {
                        return d.egd_users.first_name + " " + d.egd_users.last_name
                    }).join(', '),
                    status: 1,
                    appointment_date: appts[0]?.egd_appointments[0].schedule.slot.slot_time.toString()
                }
            )
        }
        for (let i = 0; i < appts.length; i++) {
            if (appts[0].status != 1) {
                this.history_array.push(
                    {
                        sr_no: i + 2,
                        action_date: appts[i].updated_at.toString(),
                        action_type: this.apptStatus[appts[i].status - 1],
                        reason: appts[i].reason,
                        doctor_name: appts[i]?.egd_appointments.map(d => {
                            return d.egd_users.first_name + " " + d.egd_users.last_name
                        }).join(', '),
                        status: appts[i].status,
                        appointment_date: appts[i]?.egd_appointments[0].schedule.slot.slot_time.toString()

                    }
                )
            }



        }

    }
    DateFormat(date: Date): string {
        if (!date) return null;
        return formatDate('date', 'medium', 'en-us');
    }
}
